export function formatMoney(value, currency = "MXN") {
  if (!value) return null;
  return new Intl.NumberFormat("es-MX", {
    style: "currency",
    currency,
    minimumFractionDigits: 2,
  }).format(value);
}
